// extracted by mini-css-extract-plugin
export default {"container":"style_container__URWHQ","infoPPN":"style_infoPPN__gTIsg","content":"style_content__oW7xw"};